import { geoArea, geoCentroid } from "d3-geo";
import { format, parseISO, isValid } from "date-fns";

export const slug = (s) =>
  s.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");

// Largest polygon of a country, used for labels and zoom (ignores overseas territories)
export const mainPart = (f) => {
  if (f.geometry?.type !== "MultiPolygon") return f;
  const polys = f.geometry.coordinates.map((c) => ({ type: "Feature", geometry: { type: "Polygon", coordinates: c } }));
  return polys.reduce((a, b) => (geoArea(b) > geoArea(a) ? b : a));
};

// Overseas territories that the map data bundles into their parent country
const OVERSEAS = {
  France: ([lon, lat]) => lon < -20 || lat < 35,
  Netherlands: ([lon]) => lon < -20,
  "New Zealand": ([lon]) => lon < 0,
  Norway: ([, lat]) => lat > 74,
  "South Africa": ([, lat]) => lat < -40,
};

export const splitTerritories = (f) => {
  const rule = OVERSEAS[f.properties.name];
  if (!rule || f.geometry?.type !== "MultiPolygon") return { core: f, overseas: null };
  const core = [];
  const overseas = [];
  f.geometry.coordinates.forEach((c) => (rule(geoCentroid({ type: "Polygon", coordinates: c })) ? overseas : core).push(c));
  const mk = (coords) => (coords.length ? { type: "Feature", geometry: { type: "MultiPolygon", coordinates: coords } } : null);
  return { core: mk(core), overseas: mk(overseas) };
};

export const prettyDate = (d, fmt = "d MMM yyyy") => {
  if (!d) return "";
  const p = parseISO(d);
  return isValid(p) ? format(p, fmt) : d;
};

export const TOTAL_COUNTRIES = 195;
